import { message }     from "antd";
import { getUrlParam } from './util'

export function requsetBlob(url, options){
    const defaultOpt = {};
    const newOpt = { ...defaultOpt, ...options };
    newOpt.headers = {
        ...newOpt.headers,
    };

    return fetch(url, newOpt)
        .then(checkStatus)
        .then(parseBLOB)
        .catch((err) => {
            throw err;
        });
}

const apiHostMap = {
    'lt.800best.com': '//ltserver-uat.800best.com'
}

const baseUrl = getUrlParam('baseUrl') || apiHostMap[window.location.host] || ''

export default function request(url, options){
    const defaultOpt = {};
    const newOpt = { ...defaultOpt, ...options };
    newOpt.headers = {
        Accept: "application/json",
        'Content-Type': 'application/json',
        ...newOpt.headers,
    };
    url = baseUrl + url
    return fetch(url, newOpt)
        .then(checkStatus)
        .then(parseJSON)
        .then(checkData)
        .catch((err) => {
            throw err;
        });
}

function parseJSON(response) {
    return response.json();
}

function parseBLOB(response) {
    return response.blob();
}

function checkData(result) {
    if(result.errorMsg){
        return Promise.reject(result);
    }
    return Promise.resolve(result.data);
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 400) {
        return response;
    }

    message.error(response.statusText);
    const error = new Error(response.statusText);
    throw error;
}
